import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import { fontFamily } from '../../../../../../../constants/text';
import { colors } from '../../../../../../../constants/colors';
import NetworkStatusBadge from '../../../../../../SolvPatternLibrary/NetworkStatusBadge';

const LimitMet = styled.div.withConfig({ componentId: 'sc-1nhb59p-0' })`
  font-family: ${fontFamily.book};
  color: ${colors.squid};
  font-size: 13px;
  line-height: 20px;
`;

const Subtext = styled(LimitMet).withConfig({ componentId: 'sc-1nhb59p-1' })`
  font-family: ${fontFamily.bold};
`;

const Icon = styled.img.withConfig({ componentId: 'sc-1nhb59p-2' })`
  width: 40px;
  margin: 12px 0 7px 0;
`;

const InsuranceAlways = styled.div.withConfig({ componentId: 'sc-1nhb59p-3' })`
  font-family: ${fontFamily.book};
  color: ${colors.lightText};
  font-size: 12px;
  text-align: center;
  width: 100%;
  margin: 8px auto 0;
  line-height: 18px;
`;

type Props = {
  tile: object;
};

class NoLimit extends PureComponent<Props> {
  render = () => {
    const { tile } = this.props;

    return (
      <>
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'isInNetwork' does not exist on type 'obj... Remove this comment to see the full error message */}
        <NetworkStatusBadge isInNetwork={tile.isInNetwork} />

        <Icon src="/images/insurance/no_deductible.svg" />

        <LimitMet>You have no</LimitMet>
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'subtext' does not exist on type 'object'... Remove this comment to see the full error message */}
        <Subtext>{tile.subtext}</Subtext>

        <InsuranceAlways>Insurance will always cover part of your care</InsuranceAlways>
      </>
    );
  };
}

export default NoLimit;
